import { startResponseComponentDemoStreamLoop } from './responseComponentDemoStreamLoop.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} DemoStreamCtx
 */

/** @param {DemoStreamCtx} ctx */
export function runResponseComponentDemoStream(ctx) {
  startResponseComponentDemoStreamLoop(ctx)
}
